import React from "react";
import { useTranslation } from "react-i18next";

import { styled } from "@mui/material";

import { Typography } from "@/components";
import { COLORS } from "@/utils/colors";
import getPortalType from "@/utils/getPortalType";

export type Props = {
  component: React.ElementType;
  alignLeft?: boolean;
};

export const LogoHorizontal: React.FC<Props> = ({ component, alignLeft = false }) => {
  const { t } = useTranslation();

  return (
    <Logo component={component} alignLeft={alignLeft}>
      <LogoImage src="/static/img/brands/go.png" alt="GO" />
      <LogoText>{((p): string => (p ? t(`${p}_PORTAL`) : ""))(getPortalType().toUpperCase())}</LogoText>
    </Logo>
  );
};

const Logo = styled(Typography, {
  shouldForwardProp: (propName: PropertyKey) => propName !== "alignLeft",
})<{ alignLeft: boolean }>(({ theme, alignLeft }) => ({
  fontSize: "1rem",
  fontWeight: 700,
  lineHeight: 1.5,
  color: COLORS.TEXT_LOGO,
  display: alignLeft ? "flex" : "inline-flex",
  width: alignLeft ? "100%" : "auto",
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(0, 2),
  minHeight: "56px",
  ...(alignLeft && {
    [theme.breakpoints.up("sm")]: {
      justifyContent: "flex-start",
    },
  }),
}));

const LogoImage = styled("img")({
  font: "inherit",
  width: "40px",
  height: "auto",
});

const LogoText = styled("span")({
  font: "inherit",
});
